module.exports = __webpack_public_path__ + "static/img/sad_blue.c95e6991.png";